/* unplugin-vue-components disabled */import script from "./TakeGoodsDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TakeGoodsDetails.vue?vue&type=script&setup=true&lang=js"

import "./TakeGoodsDetails.vue?vue&type=style&index=0&id=8de02bf2&lang=scss"

const __exports__ = script;

export default __exports__